import * as React from 'react';
import { ComponentProps } from 'ui/common';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { IconList } from 'ui';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { routeConstants } from 'app/routes/route-constants';

interface FactItemReportCategoryProps extends ComponentProps, FactItemProps {
  caseId: number;
  title?: string;
  tooltip?: string;
  caseNumberDomain?: string;
  dashboardId?: string;
  companyReportId?: string;
  [key: string]: any;
}

export const ReportCategoryFactItem = (props: FactItemReportCategoryProps) => {
  const { caseId, portalTarget, dashboardId, caseNumberDomain, companyReportId, tooltip, title } = props;
  let url = '';
  let icons = undefined;
  const params = new URLSearchParams();
  
  if(!caseNumberDomain || !caseId) {
    return null;
  }
  if(!!Number(dashboardId)) {
    const iconDashboard = toAbsoluteUrl('i/dashboard.svg');
    icons = [{ description: tooltip, icon: iconDashboard, value: 0, propName: 'reportCategory' }];
    url = `${routeConstants.dashboardFor(Number(dashboardId))}`;
  }
  else if(!!Number(companyReportId)) {
    const iconCompanyReport = toAbsoluteUrl('i/companyreport.svg');
    icons = [{ description: tooltip, icon: iconCompanyReport, value: 0, propName: 'reportCategory' }];
    url = `${routeConstants.companyReportFor(Number(companyReportId))}`;
  }
  params.set('cd', `${caseNumberDomain};${caseId}`);

  return <>
    {!!url ? <FactLink id={props.componentId} classNames={`fact-item icon-line`} 
      url={`${url}?${params.toString()}`} urlHrefNewTabOverride={`${url}?${params.toString()}`} params={props.params}>
      <IconList title={title} valueItems={icons} defaultIcon={undefined} portalTarget={portalTarget} />
    </FactLink> : null}
  </>;
};
